import React from "react";
import { settingsInputClassName } from "./settingsStyles";

const TextInput = ({
  value,
  onChange,
  placeholder,
  maxLength,
  disabled = false,
  readOnly = false,
}: {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  maxLength?: number;
  disabled?: boolean;
  readOnly?: boolean;
}) => (
  <input
    value={value}
    onChange={(event) => onChange(event.target.value)}
    placeholder={placeholder}
    maxLength={maxLength}
    disabled={disabled}
    readOnly={readOnly}
    className={`${settingsInputClassName} w-full read-only:bg-gray-100 read-only:text-gray-500`}
  />
);

export default TextInput;
